import { render, staticRenderFns } from "./ModuleFoodKind.vue?vue&type=template&id=5e3a4ec5&"
import script from "./ModuleFoodKind.vue?vue&type=script&lang=js&"
export * from "./ModuleFoodKind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports